// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".po-datepicker-popper {\n  z-index: 2000 !important;\n}\n\n@media only screen and (min-width: 801px) {\n\n}\n\n@media only screen and (max-width: 800px) {\n\n}\n", ""]);
// Exports
module.exports = exports;
